const stickyCta = document.querySelector('.plarium-play__sticky-cta');

/**
 * Fade out the sticky CTA when other CTA sections in view.
 */
const stickyCtaFadeOut = (stickyCtaEl) => {
  if (!stickyCtaEl) return;

  const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0.1, // Trigger when at least 10% of the element is visible
  };

  /**
   * Callback for the IntersectionObserver
   *
   * @param {IntersectionObserverEntry[]} entries - The entries to observe
   *
   * @return {void}
   */
  const observerCallback = (entries) => {
    const hasIntersection = entries.some((entry) => entry.isIntersecting);

    if (!hasIntersection) {
      stickyCtaEl.classList.add('plarium-play__sticky-cta--visible');
    } else {
      stickyCtaEl.classList.remove('plarium-play__sticky-cta--visible');
    }
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  const ctaSections = document.querySelectorAll('.plarium-play__hero, .plarium-play__cta-banner');

  ctaSections.forEach((ctaSection) => {
    observer.observe(ctaSection);
  });
};

window.addEventListener('DOMContentLoaded', () => {
  stickyCtaFadeOut(stickyCta);
});
